import { render, staticRenderFns } from "./SimpleKeyboardNumeric.vue?vue&type=template&id=33bce6f1&scoped=true"
import script from "./SimpleKeyboardNumeric.vue?vue&type=script&lang=js"
export * from "./SimpleKeyboardNumeric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bce6f1",
  null
  
)

export default component.exports